export default {
    view: "Ver más"
}